import { EnvConfigType, AmplifyConfigType } from './ConfigType'

// stg環境の設定をこちらに追加してください。
// EnvConfigTypeの変更も必要です。

const amplifyConfig: AmplifyConfigType = {
  aws_project_region: 'ap-northeast-1',
  aws_cloud_logic_custom: [
    {
      name: 'PortalAPI',
      endpoint:
        'https://mj2r4fv48c.execute-api.ap-northeast-1.amazonaws.com/stg',
      region: 'ap-northeast-1',
    },
    {
      name: 'BaseAPI',
      endpoint:
        'https://c4a9yym4o9.execute-api.ap-northeast-1.amazonaws.com/stg',
      region: 'ap-northeast-1',
    },
  ],
}

const config: EnvConfigType = {
  env: 'stg',
  amplifyConfig: amplifyConfig,
  logLevel: 'DEBUG',
  analyticsTrackingId: 'G-N5NHFG2JGK',
  viewerEndpoint: '',
  siteDomain: 'stg.manabi.poplar.co.jp',
  adminUrl: 'https://admin.stg.manabi.poplar.co.jp',
  yomokkaUrl: 'https://yomokka.stg.manabi.poplar.co.jp',
  sagasokkaUrl: 'https://sagasokka.stg.manabi.poplar.co.jp',
  mottosokkaUrl: 'https://stg.manabi.poplar.co.jp',
  maintenanceInfoUrl: 'https://yomokka.stg.manabi.poplar.co.jp/maintenance/info.txt',
  maintenanceExpiryUrl: 'https://yomokka.stg.manabi.poplar.co.jp/maintenance/expiry.txt',
}

export default config
